import {
  GET_CUSTOMER_ADDRESS_SUCCESS,
  CUSTOMER_ADDRESS_OBJECT_REQUESTING,
  CUSTOMER_ADDRESS_LIST_REQUESTING,
  LIST_CUSTOMER_ADDRESSES_SUCCESS,
  RESET_CUSTOMER_ADDRESS_ISFETCHING,
  DELETE_CUSTOMER_ADDRESS_SUCCESS
  // RESET_CUSTOMER_ADDRESS_QUERY
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  isObjectFetching: false,
  query: null,
  recordCount: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_ADDRESS_ISFETCHING: {
      return {
        ...state,
        isListFetching: false,
        isObjectFetching: false
      };
    }
    // case RESET_CUSTOMER_ADDRESS_QUERY: {
    //   return {
    //     ...state,
    //     query: null,
    //     recordCount: null
    //   };
    // }
    case CUSTOMER_ADDRESS_OBJECT_REQUESTING: {
      return {
        ...state,
        isObjectFetching: true
      };
    }
    case CUSTOMER_ADDRESS_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_CUSTOMER_ADDRESSES_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        data,
        query,
        isListFetching: false,
        recordCount: action.payload.total
      };
    }
    case GET_CUSTOMER_ADDRESS_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        ...state,
        data,
        isObjectFetching: false
      };
    }
    case DELETE_CUSTOMER_ADDRESS_SUCCESS: {
      const data = { ...state.data };
      let query = [...state.query];
      delete data[action.payload.id];
      if (query.includes(action.payload.id)) {
        query = query.filter((id) => id !== action.payload.id);
      }

      return {
        data,
        query,
        isObjectFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getDefaultAddress = (data) => {
  const customerAddressIds = Object.keys(data);
  const defaultAddressId = customerAddressIds.find((id) => data[id].isDefault);
  if (defaultAddressId) {
    return data[defaultAddressId];
  }
  return null;
};
